// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nzzd7","right":"styles_right__32JFC"};